import { IconButton, Tooltip } from '@mui/material';
import { useRef, useState } from 'react';
import { Hierarchy } from 'ui-component/icons';
import { IRecordHeaders } from 'ui-component/records/types';
import { HierarchyDialog } from '../../HierarchyDialog';
import { Popover } from './components';

export type HierarchyGridPopoverProps = {
    record: IRecordHeaders;
    hasChildrenOrParent: boolean;
};

export const HierarchyGridPopover = ({ record, hasChildrenOrParent }: HierarchyGridPopoverProps) => {
    const iconButtonRef = useRef<HTMLButtonElement>(null);

    const [isOpenPopover, setIsOpenPopover] = useState(false);
    const [isOpenFullHierarchy, setIsOpenFullHierarchy] = useState(false);

    const handleViewFullHierarchy = () => {
        setIsOpenFullHierarchy(true);
    };

    return (
        <>
            <Tooltip
                title="This record does not have a parent or child"
                disableFocusListener={hasChildrenOrParent}
                disableHoverListener={hasChildrenOrParent}
                disableTouchListener={hasChildrenOrParent}
                placement="top"
            >
                <span>
                    <IconButton ref={iconButtonRef} disabled={!hasChildrenOrParent} onClick={() => setIsOpenPopover(true)}>
                        <Hierarchy sx={{ fontSize: '20px' }} />
                    </IconButton>
                </span>
            </Tooltip>
            <Popover
                open={isOpenPopover}
                anchorEl={iconButtonRef.current}
                onClose={() => setIsOpenPopover(false)}
                record={record}
                onViewFullHierarchy={handleViewFullHierarchy}
            />
            {isOpenFullHierarchy && (
                <HierarchyDialog
                    open={isOpenFullHierarchy}
                    onClose={() => setIsOpenFullHierarchy(false)}
                    recordId={record.id}
                    initialRecord={record}
                />
            )}
        </>
    );
};
